import React from 'react';

import InboxWithArrowMobilePng from '../images/inboxWithArrowMobile.png';
import InboxWithArrowMobileWebp from '../images/inboxWithArrowMobile.webp';
import InboxWithArrowPng from '../images/inboxWithArrow.png';
import InboxWithArrowWebp from '../images/inboxWithArrow.webp';

import MailOpenedMobilePng from '../images/mailOpenedMobile.png';
import MailOpenedMobileWebp from '../images/mailOpenedMobile.webp';
import MailOpenedPng from '../images/mailOpened.png';
import MailOpenedWebp from '../images/mailOpened.webp';

import EuroIconMobilePng from '../images/euroIconMobile.png';
import EuroIconMobileWebp from '../images/euroIconMobile.webp';
import EuroIconPng from '../images/euroIcon.png';
import EuroIconWebp from '../images/euroIcon.webp';

import { OrderedList } from '../../../../../common/display/orderedList/OrderedList';
import { ImageSource } from '../../../../../common/display/imageSource/ImageSource';
import { useIntl } from '@/i18n/hooks/useIntl';

export const HowItWorksTab = () => {
  const { t } = useIntl();
  const Item = OrderedList.Item;

  return (
    <div className='margin-bottom-xxl'>
      <OrderedList>
        <Item
          image={
            <ImageSource
              image={InboxWithArrowPng}
              imageWebp={InboxWithArrowWebp}
              imageMobile={InboxWithArrowMobilePng}
              imageMobileWebp={InboxWithArrowMobileWebp}
              imageAlt={t({
                id: 'benefits.billCheckV3.modal.howItWorks.image1',
                defaultMessage: 'Discount coupon',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.billCheckV3.modal.howItWorks.description1',
            defaultMessage:
              'Ab dem ersten Tag Zugang zu MieterEngel erhalten. Mit der Anmeldung im Portal bekommst du einen persönlichen Anwalt oder Anwältin zugeteilt. Du kannst entscheiden, ob dein Anliegen schriftlich oder telefonisch geprüft werden soll.',
          })}
        />
        <Item
          image={
            <ImageSource
              image={MailOpenedPng}
              imageWebp={MailOpenedWebp}
              imageMobile={MailOpenedMobilePng}
              imageMobileWebp={MailOpenedMobileWebp}
              imageAlt={t({
                id: 'benefits.billCheckV3.modal.howItWorks.image2',
                defaultMessage: 'Moving truck',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.billCheckV3.modal.howItWorks.description2',
            defaultMessage:
              'Ab dem ersten Tag Zugang zu MieterEngel erhalten. Mit der Anmeldung im Portal bekommst du einen persönlichen Anwalt oder Anwältin zugeteilt. Du kannst entscheiden, ob dein Anliegen schriftlich oder telefonisch geprüft werden soll.',
          })}
        />
        <Item
          image={
            <ImageSource
              image={EuroIconPng}
              imageWebp={EuroIconWebp}
              imageMobile={EuroIconMobilePng}
              imageMobileWebp={EuroIconMobileWebp}
              imageAlt={t({
                id: 'benefits.billCheckV3.modal.howItWorks.image3',
                defaultMessage: 'Dolly Cart',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.billCheckV3.modal.howItWorks.description3',
            defaultMessage:
              'Ab dem ersten Tag Zugang zu MieterEngel erhalten. Mit der Anmeldung im Portal bekommst du einen persönlichen Anwalt oder Anwältin zugeteilt. Du kannst entscheiden, ob dein Anliegen schriftlich oder telefonisch geprüft werden soll.',
          })}
        />
      </OrderedList>
    </div>
  );
};
